import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { optimizationService } from '../../services/optimization/OptimizationService';

interface DeletePromptDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  promptId: string;
  promptTitle: string;
  onPromptDeleted: () => void;
}

const DeletePromptDialog: React.FC<DeletePromptDialogProps> = ({
  isOpen,
  onOpenChange,
  promptId,
  promptTitle,
  onPromptDeleted,
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await optimizationService.deletePrompt(promptId);
      onPromptDeleted();
      onOpenChange(false);
    } catch (error) {
      console.error('Error deleting prompt:', error);
      // You might want to show an error message to the user here
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Prompt</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the prompt "{promptTitle}"? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeletePromptDialog;